import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "PlaybackPlayButton.svg",
  "use": "PlaybackPlayButton.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"PlaybackPlayButton.svg\"><path d=\"M32.01,56.0208a24,24,0,1,1,24-24A24,24,0,0,1,32.01,56.0208ZM43.8762,30.22,25.892,21.2117A2,2,0,0,0,23,23.0025V41.02A2,2,0,0,0,25.892,42.81l17.9842-9.0084A2.0055,2.0055,0,0,0,43.8762,30.22Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol